import { render, staticRenderFns } from "./VpnDetails.vue?vue&type=template&id=0d697be4&scoped=true&"
import script from "./VpnDetails.vue?vue&type=script&lang=js&"
export * from "./VpnDetails.vue?vue&type=script&lang=js&"
import style0 from "./VpnDetails.vue?vue&type=style&index=0&id=0d697be4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d697be4",
  null
  
)

export default component.exports